/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1LaminationsQueryResponse } from '../../types/GetV1Laminations.ts'

export const getV1LaminationsQueryKey = () => [{ url: '/v1/Laminations' }] as const

export type GetV1LaminationsQueryKey = ReturnType<typeof getV1LaminationsQueryKey>

/**
 * {@link /v1/Laminations}
 */
export async function getV1Laminations(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1LaminationsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Laminations`,
        ...requestConfig,
    })
    return res
}

export function getV1LaminationsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1LaminationsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1LaminationsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1LaminationsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Laminations(config)
        },
    })
}

/**
 * {@link /v1/Laminations}
 */
export function useGetV1Laminations<
    TData = ResponseConfig<GetV1LaminationsQueryResponse>,
    TQueryData = ResponseConfig<GetV1LaminationsQueryResponse>,
    TQueryKey extends QueryKey = GetV1LaminationsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1LaminationsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1LaminationsQueryKey()

    const query = useQuery(
        {
            ...getV1LaminationsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
